import React from "react";
import { CONTACT_EMAIL } from "../../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0F1E] text-white/70 border-t border-white/10">
      <div className="fs-container py-12 grid md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-display text-2xl tracking-[0.14em]">
            ALWAYS ON <span className="text-[#C9A84C]">SALES</span>
          </div>
          <div className="mt-1 text-[0.65rem] uppercase tracking-[0.28em] text-white/55">
            by Favor Studio
          </div>
          <p className="mt-4 text-sm text-white/55 leading-relaxed max-w-xs">
            Your business, open 24/7. Always on. Always selling.
          </p>
          <p className="mt-2 text-xs text-white/40">
            alwaysonsales.ai · New York City
          </p>
        </div>

        <div className="text-sm text-white/65">
          <div className="text-[0.7rem] uppercase tracking-[0.22em] text-[#C9A84C] mb-3">Contact</div>
          <a
            data-testid="footer-email"
            href={`mailto:${CONTACT_EMAIL}`}
            className="hover:text-white transition-colors"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="text-sm text-white/55 md:text-right">
          © 2026 Favor Studio · Always On Sales™
          <div className="mt-1 text-[0.7rem] uppercase tracking-[0.22em] text-white/35">
            All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
